import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-2">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600">
            热门搜索标签，发现大家都在看什么
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 md:gap-3">
          {topicItems.map((topic, i) => (
            <div
              key={i}
              className={`group cursor-pointer flex items-center gap-1.5 px-3 md:px-4 py-2 md:py-2.5 rounded-full border transition-all duration-300 ${
                topic.hot
                  ? 'bg-accent-100/80 text-accent-800 border-accent-200 hover:bg-accent-500 hover:text-background-50 hover:border-accent-500'
                  : 'bg-background-100 text-foreground-700 border-background-200/70 hover:border-primary-200/50 hover:bg-background-50'
              }`}
            >
              {topic.hot && (
                <i className="ri-fire-line text-xs text-accent-500 group-hover:text-background-50 transition-colors"></i>
              )}
              <span className="text-sm font-medium whitespace-nowrap">
                #{topic.name}
              </span>
              <span className={`text-xs ${topic.hot ? 'text-accent-600 group-hover:text-background-50/80' : 'text-foreground-500'} transition-colors`}>
                {topic.count.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}